import { Component, Input, OnInit } from '@angular/core';
import { BaseReportCardComponent } from '../base-report-card.component';
import { ReportGenSvc, ReportWithDatesRequest, WorkOrderCommissionViewModel } from 'src/app/services_autogenerated/generated_services';
import { RmDateRangeServiceService } from 'src/app/services/rm-date-range-service.service';

@Component({
    selector: 'app-commission-lost',
    templateUrl: './commission-lost.component.html',
    styleUrls: ['./commission-lost.component.css'],
    standalone: false
})
export class CommissionLostComponent extends BaseReportCardComponent implements OnInit {
  @Input() mainColor: string = 'rgb(171,113,112);';
  
  dataLoading: boolean = true;

  showAllCommissionLost: boolean;
  commissionLostRecords: WorkOrderCommissionViewModel[];
  total: number;

  constructor(private reportService: ReportGenSvc,
      private rmDashboardDateRangeService: RmDateRangeServiceService) {
    super();
  }

  ngOnInit() {
    this.rmDashboardDateRangeService.getDateRangeUpdater().subscribe(changed => {
      this.dataLoading = true;
      this.startDate = changed.start;
      this.endDate = changed.end;
      
      this.reportService.getCommissionLost(new ReportWithDatesRequest({
        id: !this.companyWide ? this.employee.id : null,
        afterDate: this.startDate,
        beforeDate: this.endDate
      })).subscribe(res => {
        this.commissionLostRecords = res;
        this.total = res.reduce((acc, curr) => acc + curr.total, 0);
        this.dataLoading = false;
      })
    });
  }

  goToWorkOrder(record: WorkOrderCommissionViewModel) {
    if (record.serviceType === 'Tree Wellness') {
      window.open('wellnessWorkOrderMaintenance/' + record.workOrderId, '_blank');
    } else {
      window.open('workWorkOrderMaintenance/' + record.workOrderId, '_blank');
    }
  }
}
